import axios from '../../../utilities/axios';

export const rewardConsumeRequest = async (): Promise<void> => {
  try {
    const response = await axios.get<void>(
      `${process.env.REACT_APP_BASE_URL}/users/rewards/consume`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
